var render = function render(){var _vm=this,_c=_vm._self._c;return _c('reportContainer',{ref:"myReportContainer",style:(_vm.getStyle),attrs:{"SelectedGroups":_vm.SelectedGroups}})
}
var staticRenderFns = []

export { render, staticRenderFns }